import { Box, Button, Badge, Tooltip } from '@mui/material'
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { updateAppState } from '../../../../actions/appstate';
import React, { useState, useEffect } from "react";
import SendRestrictions from "../../../Modal/SendRestrictions"
import SendRestrictionsProductModal from '../../../Modal/SendRestrictionsProductModal';
import { getPricingDataFormatted } from '../../../DynamicTable/tilesData/pricing';
import { getPermissionMessage, userReadyOnlyStatus } from '../../../../app/util';
import useUserLoginType from '../../../../hooks/useUserLoginType';

const UpdateRestrictionsButton = (props) => {
    const { app_state, ui_state } = useSelector(state => state.app.current_state);
    let { sendRestrictionsModalOpen } = ui_state;
    const { isRestrictionsRoomType } = app_state.workspace_controls;
    const [isOpen, setisOpen] = useState(false);
    const [compState, setcompState] = useState({
        modalOpen: false,
        updateRestrictionCount: app_state.savedRestrictions.length
    });


    const userLoginType = useUserLoginType();
    const usrReadyOnlyStatus = userReadyOnlyStatus(userLoginType);

    const dispatch = useDispatch();
    // debugger; 
    useEffect(() => {
        let isSubscribed = true;

        // setNumRatesChanged(ratesChanged);

        return () => (isSubscribed = false);
    }, [app_state.savedRestrictions.length])

    const handleClick = (e) => {
        // e.stopPropagation();

        setTimeout(() => {
            setcompState(state => {
                return { ...state, modalOpen: true }
            });
            ui_state.sendRestrictionsModalOpen = true;
            dispatch({
                type: "UPDATE_STATE",
                payload: {
                    ui_state: { ...ui_state }
                }
            });
        }, 0);

        // dispatch(updateAppState("sendRestrictionsClick", { ui_state: { sendRestrictionsModalOpen: true } }));
    }

    const handleModalClose = () => {
        compState.modalOpen = false;
        setcompState(state => {
            // debugger
            return { ...state, ...compState }
        });
        ui_state.sendRestrictionsModalOpen = false;
        app_state.bulkRestrictionsSave = false;
        dispatch({
            type: 'UPDATE_STATE',
            payload: {
                app_state: { ...app_state },
                ui_state: { ...ui_state }
            }
        });
    }

    const { modalOpen, updateRestrictionCount } = compState;
    //const count = (isRestrictionsRoomType === true ) ? app_state.roomTypeRestrictions.length : app_state.savedRestrictions.length
    let count = (isRestrictionsRoomType === true) ? app_state.roomTypeRestrictions.filter(row => row.pushed !== true).length : app_state.savedRestrictions.length // LRV-1111 Fixed count not decreasing after pushing restriction

    let key = 'apiprogress';
    const [value, setValue] = useState(() => {
        const stored = sessionStorage.getItem(key);
        return stored ? JSON.parse(stored) : [];
    });

    useEffect(() => {
        const handleStorageChange = () => {
            const stored = sessionStorage.getItem(key);
            setValue(stored ? JSON.parse(stored) : []);
        };

        window.addEventListener("storage", handleStorageChange);
        window.addEventListener("sessionStorageChange", handleStorageChange);
        return () => {
            window.removeEventListener("storage", handleStorageChange);
            window.removeEventListener("sessionStorageChange", handleStorageChange);
        };
    }, [key]);

    if (isRestrictionsRoomType === 'product') {
        count = app_state?.plrDatesToPush?.length;
    }

    const isCalculating = value.length > 0;

    const buttonContent = isCalculating ? (
        <span className="pulse-btn">Calculating...</span>
    ) : (
        <span>Update</span>
    );

    const buttonElement = (
        usrReadyOnlyStatus ? (<Tooltip title={getPermissionMessage(userLoginType)} arrow followCursor>
        <Button
            className="PushRateButton-disabled"
            size="small"
            sx={{ m: "auto", minWidth: "120px" }}
            // disabled={isCalculating ? false : !count}
        >
            {buttonContent}
        </Button></Tooltip>
        ) : (
            <Button
                className="PushRateButton"
                size="small"
                sx={{ m: "auto", minWidth: "120px" }}
                onClick={!isCalculating ? handleClick : undefined}
                disabled={isCalculating ? false : !count}
            >
                {buttonContent}
            </Button>
        )
    );


    return (
        <>
            {isRestrictionsRoomType == "product" ?
                <>
                    {/* <Badge component="div" classes={{ badge: 'pulse restriction-badge' }
                    } badgeContent={count} color="primary" className='btn-ratepush' sx={{ mt: 0, mr: 0.5, position: 'relative' }}>
                        <Button className='PushRateButton' size="small" sx={{ m: "auto" }} onClick={handleClick} disabled={!count}>
                            <span>Update </span>
                        </Button>
                    </Badge> */}


                    {/* {((value.length === 0) && <Badge component="div" classes={{ badge: 'pulse restriction-badge' }} badgeContent={count} color="primary" className='btn-ratepush' sx={{ mt: 0, mr: 0.5, position: 'relative' }}>
                        <Button className='PushRateButton' size="small" sx={{ m: "auto", minWidth: "120px" }} onClick={handleClick} disabled={!count}>
                            <span>Update</span>
                        </Button>
                    </Badge>)}

                    {(value.length > 0 &&
                        <Button className='PushRateButton' size="small" sx={{ m: "auto", minWidth: "120px" }}>
                            <span className="pulse-btn">Calculating...</span>
                        </Button>)} */}



                    {isCalculating ? (
                        buttonElement
                    ) : (
                         usrReadyOnlyStatus ? (
                            buttonElement
                         ):(
                        <Badge
                            component="div"
                            classes={{ badge: "pulse restriction-badge" }}
                            badgeContent={count}
                            color="primary"
                            className="btn-ratepush"
                            sx={{ mt: 0, mr: 0.5, position: "relative" }}
                        >
                            {buttonElement}
                        </Badge>
                         )
                    )}




                    <SendRestrictionsProductModal modalOpen={sendRestrictionsModalOpen && !['active', 'processing'].includes(app_state?.plrRowCalcStatus)} handleModalClose={handleModalClose} />
                </>
                :
                <>
                    {usrReadyOnlyStatus ? (

                        <Tooltip title={getPermissionMessage(userLoginType)} arrow followCursor>
                            <Button className='PushRateButton' size="small" sx={{ m: "auto" }}>
                                <span>Update</span>
                            </Button></Tooltip>
                    ) : (
                        <><Badge component="div" classes={{ badge: 'pulse restriction-badge' }} badgeContent={count} color="primary" className='btn-ratepush' sx={{ mt: 0, mr: 0.5, position: 'relative' }}>
                            <Button className='PushRateButton' size="small" sx={{ m: "auto" }} onClick={handleClick} disabled={!count}>
                                <span>Update </span>
                            </Button>
                        </Badge>
                            < SendRestrictions modalOpen={sendRestrictionsModalOpen} handleModalClose={handleModalClose} />
                        </>)}
                </>
            }
        </>
    )

}


export default UpdateRestrictionsButton